import { PayloadAction, createSlice } from '@reduxjs/toolkit';

import { RouteEnum, RouteState } from './route.types';

const initialState: RouteState = {
  currentRoute: RouteEnum.STORE,
  routeHistory: [],
};

const routeSlice = createSlice({
  name: 'route',
  initialState,
  reducers: {
    setCurrentRoute: (state, action: PayloadAction<RouteEnum>) => {
      state.currentRoute = action.payload;
    },
    addToRouteHistory: (state, action: PayloadAction<RouteEnum>) => {
      state.routeHistory.push(action.payload);
      state.currentRoute = action.payload;
    },
  },
});

export default routeSlice.reducer;

export const { setCurrentRoute, addToRouteHistory } = routeSlice.actions;
